export const COGNITO = {
  REGION: "us-west-1",
  USER_POOL_ID: "us-west-1_8vCA0rYnH",
  APP_CLIENT_ID: "3t5qa0c3k06a8h2m0upqjg828k",
};

// Client ID: 3t5qa0c3k06a8h2m0upqjg828k